<template>
    <carousel :classes="classes" :items="items" :options="options" :show-navigation="true" :show-pagination="false">
        <template #slide="{ item }">
            <a class="item lazyload" :href="item.link" :data-bg="imagePath(item)"></a>
        </template>
    </carousel>
</template>

<script>
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "MainBannerCarousel",
    props: {
        items: {},
        classes: {
            type: String,
            default: () => ''
        }
    },
    components: {
        Carousel,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            options: {
                loop: true,
                autoplay: {
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false
                }
            },
        }
    },
    mounted() {
        document.addEventListener('lazybeforeunveil', function (e) {
            const bg = e.target.getAttribute('data-bg');
            if (bg) {
                e.target.style.backgroundImage = 'url(' + bg + ')';
            }
        });
    },
    methods: {
        imagePath(item) {
            if (this.$q.platform.is.mobile && item.mobile_image_path) {
                return item.mobile_image_path;
            }
            if (!this.$q.platform.is.mobile && item.desktop_image_path) {
                return item.desktop_image_path;
            }

            return item.image_path;
        }
    }
}
</script>
